import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { User } from '../../types/User'
import { FLAG_DEFS } from './memberFlags.constants'

interface Props {
  user: User
}

export const FlagBadges = ({ user }: Props) => {
  const active = FLAG_DEFS.filter(def => Boolean(user[def.key]))
  if (active.length === 0) return null
  return (
    <div className="tm-flag-badges">
      {active.map(def => (
        <OverlayTrigger
          key={def.key}
          placement="top"
          overlay={
            <Tooltip id={`flag-tooltip-${user.id}-${def.key}`}>
              {def.label}
            </Tooltip>
          }
        >
          <span className="tm-flag-badge" style={{ backgroundColor: def.bg }}>
            <def.Icon size={14} weight={def.weight} color={def.color} />
          </span>
        </OverlayTrigger>
      ))}
    </div>
  )
}
